module.exports = __webpack_public_path__ + "img/img_flag_bl.b08fbd58.png";